export const separateProducts = (state) => state.separateProducts;
export const products = (state) => state.products;
export const sectors = (state) => state.sectors;
export const noSectorList = (state) => state.noSectorList;
export const orderDetails = (state) => state.orderDetails;
export const couponDetails = (state) => state.couponDetails;
export const couponApplied = (state) => state.couponApplied;
export const maxProductsPerCpf = (state) => state.maxProductsPerCpf;
export const productsDetails = (state) => state.productsDetails;
export const lastOrderAndCart = (state) => state.lastOrderAndCart;
export const errorProducts = (state) => state.errorProducts;
export const selectedSector = (state) => state.selectedSector;
export const listSeats = (state) => state.listSeats;
export const selectedSeat = (state) => state.selectedSeat;
export const showSeatMap = (state) => state.showSeatMap;
export const alertSectors = (state) => state.alertSectors;
export const hoverShape = (state) => state.hoverShape;
export const couponCard = (state) => state.couponCard;
export const maxProductsPerCoupon = (state) => state.maxProductsPerCoupon;
export const showPreSale = (state) => state.showPreSale;
export const cartAbandoned = (state) => state.cartAbandoned;
export const timeToViewProducts = (state) => state.timeToViewProducts;
export const screenTimeOn = (state) => state.screenTimeOn;
export const chosenSector = (state) => state.chosenSector;
export const facebookCookies = (state) => state.facebookCookies;

export const cartProducts = (state) => {
  var sumCart = [];
  if (state.selectedSector) {
    var selectedSectorCart = state.selectedSector.products.filter((type) => {
      return type.quantidade > 0;
    });
    let sectorCartArr = [];
    sectorCartArr.push(selectedSectorCart);
    sectorCartArr.forEach((el) => sumCart.push(el));
  }
  if (state.noSectorList) {
    let nosectorCart = state.noSectorList.map((product) => {
      const type = product.filter((type) => {
        return type.quantidade > 0;
      });
      return type;
    });
    nosectorCart = nosectorCart.filter((types) => types.length > 0);
    nosectorCart.forEach((sl) => sumCart.push(sl));
  }
  return sumCart.filter((types) => types.length > 0);
};

export const productsTotal = (state) => {
  let total = 0;
  let somador = 0;
  cartProducts(state).forEach((p) => {
    p.forEach((v) => {
      somador += (v.valor + v.valor_conveniencia) * v.quantidade;
    });
  });
  total = somador;
  return total;
};

export const totalWithoutTax = (state) => {
  let total = 0;
  let somador = 0;
  cartProducts(state).forEach((p) => {
    p.forEach((v) => {
      somador += v.valor * v.quantidade;
    });
  });
  total = somador;
  return total;
};

export const productsQuantity = (state) => {
  let total = 0;
  cartProducts(state).forEach((p) => {
    p.forEach((v) => {
      total += v.quantidade;
    });
  });
  return total;
};

export const productsQuantityCoupon = (state) => {
  let total = 0;
  cartProducts(state).forEach((p) => {
    p.forEach((v) => {
      if (v.cupom) total += v.quantidade;
    });
  });
  return total;
};
